export const NEWS_EVENT_CATEGORY_GROUPS = [
  {
    category: 'Company Growth and Expansion',
    collapsed: true,
    subcategories: [
      { name: 'Acquisition or Merger', checked: false },
      { name: 'Divestiture/Split-off', checked: false },
      { name: 'Joint Venture', checked: false },
      { name: 'New Products/Services', checked: false },
      { name: 'Geographic Expansion', checked: false },
      { name: 'Significant Organisational Change', checked: false },
    ],
  },
  {
    category: 'Corporate Governance & Regulatory',
    collapsed: true,
    subcategories: [
      { name: 'Change in Senior Management', checked: false },
      { name: 'Change in Board of Directors', checked: false },
      { name: 'Departure of Key Executive', checked: false },
      { name: 'Regulatory Action', checked: false },
      { name: 'Change in Corporate Structure', checked: false },
      { name: 'Change in Dividend Policy', checked: false },
      { name: 'Share Buyback Program', checked: false },
      { name: 'Legal/Regulatory Event', checked: false },
    ],
  },
  {
    category: 'Operational & Financial Events',
    collapsed: true,
    subcategories: [
      { name: 'Product Recall', checked: false },
      { name: 'Significant Cost/Expense Reduction', checked: false },
      { name: 'Significant Asset Write-down', checked: false },
      { name: 'Disruption of Operations', checked: false },
      { name: 'Significant Financial Performance Decline', checked: false },
      { name: 'Fraud or Misconduct', checked: false },
      { name: 'Changes in Accounting Policy', checked: false },
      { name: 'Change in Credit Rating', checked: false },
      { name: 'Significant Increase in Revenue', checked: false },
      { name: 'Significant Increase in Profitability', checked: false },
      { name: 'Launch of New Product or Service', checked: false },
    ],
  },
  {
    category: 'Market Performance & Shareholder Action',
    collapsed: true,
    subcategories: [
      { name: 'Major Investment or Divestment', checked: false },
      { name: 'Analyst Recommendation Change', checked: false },
      { name: 'Shareholder Activism', checked: false },
      { name: 'Significant Stock Price Fluctuation', checked: false },
      { name: 'Market Rumour or Speculation', checked: false },
      { name: 'Trading Suspension', checked: false },
      { name: 'Change in Index Inclusion', checked: false },
      { name: 'Analyst Meeting', checked: false },
    ],
  },
  {
    category: 'Risk & Uncertainty Events',
    collapsed: true,
    subcategories: [
      { name: 'Restructuring or Reorganisation', checked: false },
      { name: 'Investigation or Lawsuit', checked: false },
      { name: 'Cybersecurity Incident', checked: false },
      { name: 'Natural Disaster or Major Event', checked: false },
      { name: 'Negative Publicity', checked: false },
      { name: 'Labour Dispute', checked: false },
      { name: 'Environmental Incident', checked: false },
      { name: 'Product Liability Claim', checked: false },
      { name: 'Patent Infringement Claim', checked: false },
    ],
  },
  {
    category: 'External Macroeconomic & Political',
    collapsed: true,
    subcategories: [
      { name: 'External Political Event', checked: false },
      { name: 'Economic downturn or Recession', checked: false },
      { name: 'Changes in Government Policy', checked: false },
      { name: 'Industry-wide Event', checked: false },
      { name: 'Change in Exchange Rates', checked: false },
      { name: 'Change in Interest Rates', checked: false },
      { name: 'Changes in Tax Law', checked: false },
      { name: 'Significant Change in Commodity Prices', checked: false },
      { name: 'Major Technological Advancement', checked: false },
    ],
  },
  {
    category: 'Disputes/Legal Matters',
    collapsed: true,
    subcategories: [
      { name: 'Legal Proceedings', checked: false },
      { name: 'Shareholder Lawsuit', checked: false },
      { name: 'Regulatory Investigation', checked: false },
      { name: 'Arbitration or Mediation', checked: false },
      { name: 'Intellectual Property Dispute', checked: false },
      { name: 'Litigation', checked: false },
      { name: 'Bankruptcy Filing or Reorganization', checked: false },
      { name: 'Insolvency', checked: false },
      { name: 'Restructuring Plan', checked: false },
    ],
  },
];
